// The basic idea here is to blur the focused element
// if it was mouse clicked, but preserve the focus
// if it was tabbed to or "clicked" via the keyboard.
// This allows us to use focus highlight styling
// (see focus-highlight.scss) when navigating
// via the keyboard but disable the lingering
// focus state when clicked via mouse.
// We can tell if the event was actually a mouse click by looking at e.detail
// per https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail:
// - For click or dblclick events, UIEvent.detail is the current click count.
// - For mousedown or mouseup events, UIEvent.detail is 1 plus the current click count.
// - For all other UIEvent objects, UIEvent.detail is always zero.
export function blurOnClick(element) {
    const onClick = (e) => {
        if (e.detail !== 0) {
            element.blur();
        }
    };
    element.addEventListener('click', onClick);
    return {
        destroy() {
            element.removeEventListener('click', onClick);
        },
    };
}
